'use strict';
var PortfolioItemModel = require('./PortfolioItemModel');
var endpoints = require('dibs-endpoints');

module.exports = PortfolioItemModel.extend({

    url: function () {
        return endpoints.cartPortfolioAddItem(this.get('item.id'));
    },

    defaults: {
        loggedOut: false,
        createdDate: '',
        item: {}
    }

});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/portfolio/CartPortfolioItemModel.js
// module id = 53
// module chunks = 2 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56